@if (isOpen()) {
    <div [@menuAnimation] class="flex overflow-hidden fixed inset-0 z-50 flex-col" style="background-color: var(--pax-fullscreen-menu-background)">
        <div class="absolute top-6 right-6">
            <button (click)="closeMenu.emit()" class="text-[var(--pax-fullscreen-menu-text-color)] hover:rotate-90 transition-transform duration-300">
                <lucide-icon name="x" size="24" />
            </button>
        </div>
        <!-- Language Switcher for Desktop -->
        <div class="hidden px-8 pt-20 md:block">
            <div class="text-sm">
                @for (language of availableLanguages(); track language; let last = $last) {
                    <span
                        [class.font-bold]="currentLang() === language"
                        class="text-[var(--pax-footer-text-color)] transition-colors cursor-pointer hover:text-[var(--pax-footer-text-color-hover)]"
                        (click)="languageChange.emit(language)"
                    >
                        {{ language.toUpperCase() }}
                    </span>
                    @if (!last) {
                        <span class="mx-2 text-[var(--pax-footer-divider-color)]">|</span>
                    }
                }
            </div>
        </div>
        <!-- Navigation Items -->
        <nav class="flex flex-grow justify-center items-center">
            <ul class="space-y-8">
                @for (item of navigationItems(); track $index) {
                    <li [@menuItems]>
                        <a
                            [routerLink]="[item.path]"
                            (click)="closeMenu.emit()"
                            class="flex items-center transition-opacity group"
                            [style.color]="'var(--pax-fullscreen-menu-text-color)'"
                            [style.opacity]="'var(--pax-fullscreen-menu-text-opacity)'"
                        >
                            <lucide-icon [name]="item.icon" size="24" class="mr-4 transition-transform transform group-hover:scale-110" />
                            <span class="text-2xl font-light tracking-wider">{{ item.label }}</span>
                        </a>
                    </li>
                }
            </ul>
        </nav>
        <!-- Language Switcher for Mobile -->
        <div class="px-8 pb-16 md:hidden">
            <div class="flex justify-center text-sm">
                @for (language of availableLanguages(); track language; let last = $last) {
                    <span
                        [class.font-bold]="currentLang() === language"
                        class="text-[var(--pax-fullscreen-menu-language-text-color)] transition-colors cursor-pointer hover:text-[var(--pax-fullscreen-menu-language-text-color-hover)]"
                        (click)="languageChange.emit(language)"
                    >
                        {{ language.toUpperCase() }}
                    </span>
                    @if (!last) {
                        <span class="mx-2 text-[var(--pax-fullscreen-menu-language-divider-color)]">|</span>
                    }
                }
            </div>
        </div>
    </div>
}
